<template lang="pug">
.mt-4
  h2 Facturen

  v-progress-linear(indeterminate, v-if='!initialized')
  v-layout.mt-3(column, v-else)
    v-card.elevation-0
      v-data-table(
        :headers='headers',
        :items='invoices',
        :expand='true',
        item-key='id',
        :pagination.sync='pagination',
        :loading='loading',
        :must-sort='true',
        :rows-per-page-items='[10, 50]',
        hide-actions
        )

        template(slot='items', slot-scope='props')
          tr
            td {{ props.item.number }}
            td {{ props.item.invoiceForMonth | moment('MM-YYYY') }}
            td {{ props.item.amountCents / 100 | currency }}
            td
              v-chip(v-if='props.item.status === "sent"', color='error', text-color='white'): b Openstaand
              v-chip(v-if='props.item.status === "paid"', color='success', text-color='white'): b Betaald
            td
              v-btn(flat, @click='downloadAsPdf(props.item)', color='success')
                v-icon.mr-2 fas fa-file-pdf
                span Download factuur
</template>

<script>
export default {
  data () {
    return {
      invoices: [],

      loading: false,
      initialized: false,
      search: this.$store.state.filters.search,
      headers: [
        {
          text: 'Factuurnr.',
          value: 'number'
        },
        {
          text: 'Datum',
          value: 'invoiceForMonth'
        },
        {
          text: 'Bedrag',
          value: 'amountCents'
        },
        {
          text: 'Status',
          value: 'status'
        },
        {
          text: null,
          sortable: false
        }
      ],

      pagination: {
        sortBy: 'invoiceForMonth',
        descending: true
      }
    }
  },

  methods: {
    async downloadAsPdf (invoice) {
      const pdfAsBase64 = await this.$store.dispatch('graphqlQuery', {
        name: 'downloadInvoiceAsPdf',
        variables: {
          id: invoice.id
        }
      })

      this.$store.dispatch('files/downloadBase64', {
        base64: pdfAsBase64,
        name: invoice.number + '.pdf',
        fileType: 'application/pdf'
      })
    }
  },

  async created () {
    this.loading = true

    this.invoices = await this.$store.dispatch('graphqlQuery', {
      name: 'getInvoices',
      variables: {
        orgId: this.$store.state.organization.currentOrgId
      }
    })

    this.loading = false

    this.initialized = true
  }
}
</script>

<style lang="scss" scoped>
</style>
